// extracted by css-extract-rspack-plugin
export default {"commentWrap":"CommentModal__commentWrap--gGLVv"};